<template>
  <Head>
    <title>Products | NutriStudents K-12</title>
    <meta name="description" content="Products">
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <div class="flex">
        <!-- <a href="#" class="link-color"> --><U>Templates</U><!-- </a> -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
        </svg>
        <inertia-link :href="route('recipes')" class="link-color"><U>Parent Portal Setting</U></inertia-link>
      </div>
    </BreadcrumLayout>



    <form action="#" enctype="multipart/form-data">
      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-6/12">
          <h1 class="heading-color xl:text-4xl sm:text-2xl text-base font-bold">
            Parent Portal Setting
          </h1>
        </div>
        <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">


          <button type="button" @click="save" class="
              menu1-background-color
              w-full
              inline-flex
              justify-center
              rounded-md
              font-bold
              px-4
              py-3.5
              uppercase
              button-color
              text-white
              sm:ml-3 sm:w-40
              mt-3
              sm:mt-0
              mx-2
            ">
            Save
          </button>
        </div>
      </PageTitleLayout>

      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-full">
          <div class="text-base text-gray-500 font-bold"></div>
        </div>
      </PageTitleLayout>




      <PageTitleLayout>
        <div class="
            flex
            justify-between
            shadow
            py-8
            mt-4
            align-middle
            min-w-full
            bg-white
            rounded-lg
            min-height-third
          ">
          <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 pt-6">
            <label class="font-bold text-gray-700">Home Image</label>
            <div>
              <input accept="image/*" type="file" id="recipe_image" name="recipe_image" class="
                    h-9
                    xl:mt-0
                    mt-4
                    sm:w-64
                    w-48
                    shadow-sm
                    block
                    sm:text-sm
                    border
                    p-1
                    border-gray-300
                    rounded-lg
                    input-background
                  " v-on:change="onImageChange" />

              <div v-if="image" class="relative w-20 mt-2">
                <img :src="image" class="xl:mt-0 mt-4" width="100" height="100" />
                <!-- <i class="fa fa-times absolute top-0 right-0" aria-hidden="true" @click="removeImage"></i> -->
              </div>
              <div v-if="form.errors.recipe_image" class="validation_error_msg">
                {{ form.errors.recipe_image }}
              </div>
              <div class="loader-15" v-if="uploadProgress"></div>
            </div>
          </div>
        </div>
      </PageTitleLayout>

    </form>


  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";


export default {
  props: ['siteSetting'],
  components: {
    DefaultLayout,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout
  },


  data() {
    return {
      uploadProgress: false,
      form: this.$inertia.form({
        image: null
      }),
      image: this.siteSetting?.value,
    }
  },


  methods: {
    onImageChange(e) {
      let img_file = e.target.files || e.dataTransfer.files;
      if (!img_file.length) {
        return;
      } else {
        let sizes = Math.round(img_file[0].size / 1024);
        if (sizes <= 4096) {

          this.uploadProgress = true;
          let $this = this;

          Vapor.store(e.target.files[0], {
            visibility: 'public-read',
            progress: (progress) => { },
          }).then((response) => {
            $this.createRecipeImage(img_file[0]);
            $this.uploadProgress = false;
            $this.form.image = response;
            console.log("vapor response", response);
          });
          // e.target.value = '';
        } else {
          this.$toast.error(
            "Error: The size limit for images is 4MB. Please reduce the file size and try again."
          );
          e.target.value = "";
        }
        console.log(
          "File " +
          img_file[0].name +
          " is " +
          "sizes = " +
          sizes +
          " = " +
          img_file[0].size +
          " bytes in size"
        );
      }

      //console.log(e.target.files[0]);
      // this.form.recipe_image = e.target.files[0];
      // let img_file = e.target.files || e.dataTransfer.files;
      // if (!img_file.length)
      //     return;
      // this.createRecipeImage(img_file[0]);
    },
    createRecipeImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage() {
      this.form.image = "";
      this.image = "";
      document.querySelector("#recipe_image").value = "";
    },

    save() {

      this.form.post(this.route("parent-portal.settings.save"), {
        onSuccess: () => {
          this.$toast.success("Hero Image Added Successfully!");
        },
      });
    },

  },

};


</script>


<style scoped>
.loader-15 {
  background: currentcolor;
  position: relative;
  animation: loader-15 1s ease-in-out infinite;
  animation-delay: 0.4s;
  width: 0.25em;
  height: 0.5em;
  margin: 37px auto;
}

.loader-15:after,
.loader-15:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  background: inherit;
  animation: inherit;
}

.loader-15:before {
  right: 0.5em;
  animation-delay: 0.2s;
}

.loader-15:after {
  left: 0.5em;
  animation-delay: 0.6s;
}

@keyframes loader-15 {

  0%,
  100% {
    box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
  }

  50% {
    box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
  }
}
</style>
